import React from 'react';
import { Rocket, SlidersHorizontal, Activity, ShieldAlert, Link2, Lock } from 'lucide-react';
import { Card, ReadMore } from '../ui';

const BLOCKS = [
  [Rocket, 'Attivazione automatica', 'I nuovi dispositivi si configurano da soli alla prima accensione (zero-touch): app, file, certificati e impostazioni aziendali arrivano senza interventi manuali.'],
  [SlidersHorizontal, 'Controllo e regole', 'Oltre 250 restrizioni e criteri di sicurezza da una console web: dispositivi solo aziendali, a uso misto o personali (BYOD), con regole anche per fasce orarie.'],
  [Activity, 'Monitoraggio continuo', 'Avvisi sullo stato dell\'hardware, uso delle app, traffico di rete e posizione del dispositivo in caso di smarrimento; assistenza con visione remota dello schermo.'],
  [ShieldAlert, 'Difesa dalle minacce mobili', 'Rilevamento di malware, trojan, ransomware e vulnerabilità non ancora note con algoritmi di intelligenza artificiale, protezione anti-phishing sui link e firewall intelligente.'],
  [Link2, 'Integrazioni', 'Accesso unico con i sistemi aziendali (Azure AD, Google, LDAP, SAML) e invio degli eventi di sicurezza ai sistemi di monitoraggio (SIEM/SOAR).'],
  [Lock, 'Privacy e GDPR', 'Dati personali e aziendali separati sullo stesso dispositivo, servizio con dati ospitati in Italia oppure installato presso l\'azienda.'],
];

export default function MdmPresentation() {
  return (
    <Card className="p-6 mb-6" data-testid="mdm-presentation">
      <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-2">Computer · Smartphone · Tablet</p>
      <h2 className="font-heading text-lg mb-2">Tutti i dispositivi aziendali sotto controllo, da un'unica console</h2>
      <ReadMore className="text-sm text-[#A3A3A3] max-w-3xl mb-6">Una piattaforma italiana di gestione e sicurezza dei dispositivi (MDM e Mobile Threat Defense) per Android, iOS, iPadOS e Windows. Smart Info la configura, la gestisce e ti aiuta a rispettare gli obblighi NIS2 e GDPR sui dispositivi.</ReadMore>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {BLOCKS.map(([Icon, t, d], i) => (
          <div key={t} className="border border-[#1F242C] rounded-sm p-4 hover:border-[#D4AF37]/60 transition-colors" data-testid={`mdm-block-${i}`}>
            <Icon size={18} className="text-[#D4AF37] mb-3" />
            <p className="text-sm font-semibold mb-1">{t}</p>
            <ReadMore clamp="max-sm:line-clamp-2" className="text-sm text-[#A3A3A3] leading-relaxed">{d}</ReadMore>
          </div>
        ))}
      </div>
    </Card>
  );
}
